import { useEffect, useState } from "react";

/**
 * Subscribes to a media query.
 *
 * Used by the data table to switch between the full table and the card list.
 * That decision has to be reactive rather than sampled once — rotating a tablet
 * or dragging a window across the breakpoint must re-render, which is exactly
 * what the old resize-listener-based Vaadin `ResizableViewFrame` was doing by
 * hand.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window === "undefined" ? false : window.matchMedia(query).matches,
  );

  useEffect(() => {
    const list = window.matchMedia(query);
    const onChange = () => setMatches(list.matches);
    onChange();
    list.addEventListener("change", onChange);
    return () => list.removeEventListener("change", onChange);
  }, [query]);

  return matches;
}

/** Tailwind's `md` breakpoint — below this the table renders as cards. */
export function useIsCompact(): boolean {
  return useMediaQuery("(max-width: 767px)");
}
